// extracted by mini-css-extract-plugin
module.exports = {"contactItem":"ContactItem-module--contactItem--33g6O","simpleText":"ContactItem-module--simpleText--fgnN7"};